import { Stack, TextField } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { z } from "zod"
import { useSchema } from "./schema"

export function EditDialogBody() {
    const { translateText } = useLocalization()
    const schema = useSchema()
    const { control } = useFormContext<z.infer<typeof schema>>()

    return (
        <Stack direction="row" gap={1}>
            <Controller
                control={control}
                name="name"
                render={({ field, fieldState }) => (
                    <TextField
                        sx={{ minWidth: "360px" }}
                        label={translateText(155)}
                        inputCounter
                        inputProps={{ maxLength: 50 }}
                        required
                        size="extralarge"
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <Controller
                control={control}
                name="description"
                render={({ field, fieldState }) => (
                    <TextField
                        sx={{ width: "510px" }}
                        label={translateText(617)}
                        size="extralarge"
                        inputCounter
                        inputProps={{ maxLength: 200 }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
        </Stack>
    )
}
